import Button from "../../ui/Button/Button";
import styles from "./CtaBand.module.css";

function CheckIcon() {
  return (
    <svg viewBox="0 0 16 16" width="13" height="13" fill="none" aria-hidden="true">
      <path d="M3 8.5 6.2 11.5 13 4.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const defaultPoints = [
  "Free 20-minute call",
  "No long contracts",
  "Reply within one working day",
];

function PresenceVisual() {
  return (
    <div className={styles.visual} aria-hidden="true">
      <svg className={styles.map} viewBox="0 0 400 360" fill="none">
        <g stroke="currentColor" strokeWidth="1">
          <path d="m0 100 400-77M0 190 400 113M0 280l400-77M0 370l400-77M65 0l70 360M165 0l70 360M265 0l70 360M365 0l70 360" />
        </g>
        <g fill="currentColor">
          <path d="m83 55 59-11 13 65-59 11zM184 37l59-11 13 65-59 11zM285 18l59-11 13 65-59 11zM102 145l59-11 13 65-59 11zM304 107l59-11 13 65-59 11zM18 252l58-11 13 65-58 11zM121 234l59-11 13 65-59 11zM222 215l59-11 13 65-59 11zM323 196l59-11 13 65-59 11z" opacity="0.25" />
        </g>
        <path d="m0 190 183-35 18 92 199-38" stroke="#7ba6ff" strokeOpacity="0.35" strokeWidth="2" strokeDasharray="5 7" />
        <circle cx="201" cy="153" r="100" fill="#1478c8" fillOpacity="0.05" stroke="#7ba6ff" strokeOpacity="0.12" />
        <circle cx="201" cy="153" r="67" fill="#1478c8" fillOpacity="0.07" stroke="#7ba6ff" strokeOpacity="0.2" />
        <circle cx="201" cy="153" r="33" fill="#1478c8" fillOpacity="0.15" stroke="#7ba6ff" strokeOpacity="0.3" />
        <circle cx="84" cy="174" r="5" fill="#95b8ff" />
        <circle cx="297" cy="229" r="5" fill="#95b8ff" />
      </svg>
      <div className={styles.pin}>
        <svg viewBox="0 0 54 66" width="54" height="66" fill="none"><path d="M27 64s25-23 25-39C52 11.2 40.8 1 27 1S2 11.2 2 25c0 16 25 39 25 39Z" fill="#1478c8" stroke="#7ca6ff" /><circle cx="27" cy="25" r="9" fill="#fff" /></svg>
      </div>
      <span className={styles.mapLabel}>A world of possibilities.</span>
      <div className={styles.locationCard}>
        <span className={styles.locationIcon}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M4 9h16v12H4zM3 9l2-6h14l2 6M9 21v-7h6v7" /></svg>
        </span>
        <span><strong>Your business.</strong><span>Ready to be discovered.</span></span>
        <span className={styles.locationArrow}>↗</span>
      </div>
    </div>
  );
}

export default function CtaBand({
  title = "Your next chapter starts online.",
  text = "Let’s build a digital presence that does your business justice. Tell us where you want to go. We’ll help you get there.",
  primary = { label: "Let’s talk about your business", href: "/contact" },
  secondary = null,
  points = defaultPoints,
}) {
  return (
    <section className={styles.band} data-reveal="">
      <div className="container">
        <div className={styles.card}>
          <div className={styles.copy}>
            <span className={styles.eyebrow}><span />Made to move you forward</span>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.text}>{text}</p>
            <div className={styles.actions}>
              <Button href={primary.href} size="lg" variant="light" className={styles.primary}>
                {primary.label}
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5" /></svg>
              </Button>
              {secondary && (
                <Button href={secondary.href} size="lg" variant="outlineLight">
                  {secondary.label}
                </Button>
              )}
            </div>
            {points?.length > 0 && (
              <ul className={styles.points}>
                {points.map((point) => (
                  <li key={point}><CheckIcon />{point}</li>
                ))}
              </ul>
            )}
          </div>
          <PresenceVisual />
        </div>
      </div>
    </section>
  );
}
